export class DocumentRequestResponse {
  documentNames?: string[];
  documentType?: string;
  errorMessage?: string;

  constructor(opts?: Partial<DocumentRequestResponse>) {
    if (opts?.documentNames != null) {
      this.documentNames = opts.documentNames;
    }
    if (opts?.documentType != null) {
      this.documentType = opts.documentType;
    }
    if (opts?.errorMessage != null) {
      this.errorMessage = opts.errorMessage;
    }
  }
}
